module.exports = __webpack_public_path__ + "img/cointo-screenshot-02.5af0252c.png";